import React, { useState, useEffect } from 'react';

function ModalConvPatient({ API_URL, token, patient, onFermer, onOuvrirConv }) {
    const [conversations, setConversations] = useState([]);

    useEffect(() => {
        if (patient) chargerConversations();
    }, [patient]);

    async function chargerConversations() {
        const res  = await fetch(`${API_URL}/patients/${patient.id}/conversations`,
            { headers: { Authorization: `Bearer ${token}`, "ngrok-skip-browser-warning": "true" } });
        const data = await res.json();
        setConversations(data);
    }

    async function nouvelleConversation() {
        try {
            const res  = await fetch(`${API_URL}/conversations`, {
                method : 'POST',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', "ngrok-skip-browser-warning": "true" },
                body   : JSON.stringify({ patient_id: patient.id })
            });
            const conv = await res.json();
            onOuvrirConv(conv.id, patient);
        } catch(e) {
            alert('Erreur lors de la création de la consultation.');
        }
    }

    if (!patient) return null;

    return (
        <div
            onClick = {e => e.target === e.currentTarget && onFermer()}
            style={{
                display: 'flex', position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 100,
                alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div style={{
                background: 'var(--bg-light)', border: '1px solid var(--border)',
                padding: '32px', borderRadius: '12px',
                width: '480px', maxWidth: '90vw', maxHeight: '80vh',
                display: 'flex', flexDirection: 'column'
            }}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: 500, color: 'var(--white)' }}>
                        Consultations — {patient.prenom} {patient.nom}
                    </h3>
                    <button
                        onClick = {onFermer}
                        style={{
                            background: 'none', border: 'none',
                            color: 'var(--text-muted)', fontSize: '18px',
                            cursor: 'pointer', padding: '4px 8px'
                        }}
                    >✕</button>
                </div>

                {/* Liste conversations */}
                <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {conversations.length === 0 ? (
                        <div style={{ color: 'var(--text-muted)', fontSize: '13px', padding: '20px', textAlign: 'center' }}>
                            Aucune consultation pour ce patient
                        </div>
                    ) : (
                        conversations.map(conv => {
                            const date = new Date(conv.updated_at).toLocaleString('fr-FR', {
                                day: '2-digit', month: '2-digit', year: 'numeric',
                                hour: '2-digit', minute: '2-digit'
                            });
                            return (
                                <div
                                    key     = {conv.id}
                                    onClick = {() => onOuvrirConv(conv.id, patient)}
                                    style={{
                                        padding: '12px 16px', background: 'var(--bg)',
                                        border: '1px solid var(--border)', borderRadius: '8px',
                                        cursor: 'pointer', display: 'flex',
                                        justifyContent: 'space-between', alignItems: 'center'
                                    }}
                                >
                                    <div>
                                        <div style={{ fontSize: '13px', color: 'var(--text)' }}>{date}</div>
                                        <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
                                            {conv.nb_messages} message(s)
                                        </div>
                                    </div>
                                    <span style={{ color: 'var(--text-muted)' }}>→</span>
                                </div>
                            );
                        })
                    )}
                </div>

                {/* Bouton nouvelle consultation */}
                <button
                    onClick = {nouvelleConversation}
                    style={{
                        marginTop: '20px', padding: '9px 18px',
                        background: 'var(--white)', color: '#1a1a1a',
                        border: 'none', borderRadius: '8px',
                        fontSize: '13px', fontWeight: 500, cursor: 'pointer'
                    }}
                >
                    + Nouvelle consultation
                </button>
            </div>
        </div>
    );
}

export default ModalConvPatient;